<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title
          >UoM Group Definition -
          <span style="color: red">
            {{ groupItem.UgpName }}</span
          ></v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn color="primary" small text to="/inventory/uom-groups">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-btn @click="newGroup" color="primary" small>
              <v-icon left>mdi-plus</v-icon>New Group Definition
            </v-btn>
          </v-col>

          <v-col cols="12">
            <v-data-table
              :items-per-page="2000"
              :headers="headers"
              :items="groupDef"
              :search="search"
              :mobile-breakpoint="0"
            >
              <!-- name template -->
              <template v-slot:item.Name="{ item }">
                <v-btn
                  color="primary"
                  text
                  :to="`/statement/supplier/${item.id}`"
                >
                  {{ item.Name }}
                  <v-icon right>mdi-eye</v-icon>
                </v-btn>
              </template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="accent" text icon @click="openEditModal(item)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
          </v-col>
        </v-row>
        <!-- dialog -->
        <v-dialog width="1050" v-model="defDialog">
          <v-toolbar dense color="accent" dark>
            <v-toolbar-title>New Group Definition</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="defDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card>
            <v-card-text>
              <v-row>
                <v-col cols="3">
                  <v-text-field
                    name="newDefAltQty"
                    label="Alt Qty."
                    v-model="defItem.AltQty"
                  ></v-text-field>
                </v-col>

                <v-col cols="3">
                  <v-autocomplete
                    name="newDefUomEntry"
                    v-model="defItem.UomEntry"
                    :items="uom"
                    item-text="UomName"
                    item-value="id"
                    label="Alt UoM"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="3">
                  <v-text-field
                    name="newDefBaseQty"
                    label="Base Qty."
                    v-model="defItem.BaseQty"
                  ></v-text-field>
                </v-col>

                <v-col cols="3">
                  <v-text-field
                    name="newDefUomName"
                    label="Base UoM"
                    v-if="groupItem.ouom"
                    v-model="groupItem.ouom.UomName"
                    readonly
                    filled
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-btn
                    color="accent"
                    small
                    @click="createugp1"
                    :loading="loader"
                  >
                    <v-icon left>mdi-content-save</v-icon>Save
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end -->

        <!-- editing dialog -->
        <v-dialog v-model="editingDialog" max-width="650px">
          <v-card>
            <v-toolbar dense color="primary" dark>
              <v-toolbar-title>Edit Group Definition</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="editingDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-row>
                  <v-col cols="12" xs="12" sm="12" md="12">
                    <v-autocomplete
                      name="newDefUomEntry"
                      v-model="editItem.UomEntry"
                      :items="uom"
                      item-text="UomName"
                      item-value="id"
                      label="Alt UoM"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="6">
                    <v-text-field
                      label="Base Qty"
                      outlined
                      dense
                      v-model="editItem.BaseQty"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="6">
                    <v-text-field
                      label="Selling Price"
                      outlined
                      dense
                      v-model="editItem.SellingPrice"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="6">
                    <v-text-field
                      label="Buying Price"
                      outlined
                      dense
                      v-model="editItem.BuyingPrice"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-btn color="accent" @click="updateDef" :loading="loader">
                      <v-icon left>mdi-content-save</v-icon> Update
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of editing dialog -->
      </v-card-text>
      <snackbar ref="snackbar"></snackbar>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  computed: {
    ...mapGetters(["user"]),
  },
  data: () => ({
    loader: false,
    search: null,
    dataItem: {},
    groupItem: {},
    defItem: {},
    groupDef: [],
    uom: [],
    defDialog: false,
    editingDialog: false,
    editItem: {},
    headers: [
      { text: "Alt Qty", value: "AltQty" },
      { text: "Alt Uom", value: "uomentry.UomName" },
      { text: "EQ", value: "eq" },
      { text: "Base Qty", value: "BaseQty" },
      { text: "Base Uom", value: "baseuom.ouom.UomName" },
      { text: "Selling Price", value: "SellingPrice" },
      { text: "Buying Price", value: "BuyingPrice" },
      { text: "Action", value: "action" },
    ],
  }),
  watch: {
    "$route.params.id": {
      handler: "getGroupData",
      immediate: true,
    },
  },
  methods: {
    newGroup() {
      this.defDialog = true;
    },
    openEditModal(data) {
      this.editItem = data;
      this.editingDialog = true;
    },
    createugp1() {
      const data = {
        UgpEntry: this.groupItem.id,
        UomEntry: this.defItem.UomEntry,
        AltQty: this.defItem.AltQty,
        BaseQty: this.defItem.BaseQty,
      };
      const url = "/createugp1";
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then(() => {
          location.reload();
        })
        .catch(() => {});
    },
    getUom() {
      const self = this;
      this.$store
        .dispatch("get", `/oums`)
        .then((res) => {
          self.uom = res.ResponseData;
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGroupData(val) {
      const self = this;
      this.$store
        .dispatch("get", `/ougp/${val}`)
        .then((res) => {
          self.groupItem = res.ResponseData;
          self.groupDef = res.ResponseData.groupDef;
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    save(data) {
      const url = "/ougp";
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then(() => {
          // self.$refs.snackbar.show("Item group created", "green");
          self.$router.push("/inventory/uom-groups");
        })
        .catch(() => {});
    },
    updateDef() {
      let data = this.editItem;
      const url = "/edit-group-def";
      // const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            location.reload();
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            this.loader = false;
          }
        })
        .catch(() => {});
    },
  },
  created() {
    this.getUom();
  },
};
</script>